export default __webpack_public_path__ + "static/media/480.349ed5c1.gif";